import { LIST_STUDENTS_QUERY } from "@/app/gql/students/students_queries";
import useMGQuery from "@/app/utils/gql/useMGQuery";
import UserUtils from "@/app/utils/users/user_utils";
import { debounce } from "lodash";
import { useCallback, useMemo, useState } from "react";

export const useHomePageStudentSearch = () => {
  const [searchText, setSearchText] = useState("");

  const { data, loading } = useMGQuery(LIST_STUDENTS_QUERY, {
    variables: {
      q: searchText,
      limit: 20,
      page: 1,
      filterTeacherId: parseInt(UserUtils.getCurrentUserId()),
    },
  });

  const students = useMemo(
    () =>
      data?.students?.edges
        ? data.students.edges.map(({ node }) => ({
            id: node.id,
            full_name: `${node.f_name} ${node.l_name}`,
            devices: (node.devices ?? []).map((d) => ({
              device_uuid: d.device_uuid,
              serial: d.serial,
            })),
          }))
        : [],
    [data]
  );

  const search = (text) => setSearchText(text);
  const debounceSearch = useCallback(debounce(search, 250), []);

  return { students, loading, debounceSearch, searchText, setSearchText };
};

export default useHomePageStudentSearch;
